<!--
 * @Author: your name
 * @Date: 2022-01-12 10:01:12
 * @LastEditTime: 2022-03-10 10:40:38
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \scp-web\src\views\screenWalls\components\PeopleData.vue
-->

<template>
  <!-- <el-scrollbar> -->
  <div class="StatsBox flex-row" style="padding-top: 15px">
    <div style="width: 50%; display: flex; height: 100%">
      <div class="StatsBox__chart" id="pieChart" style="height: 100%; width: 50%"></div>
    </div>
    <ul class="StatsBox__header flex-valign">
      <!-- <li>
        <h4 class="bg-blue">当前人流量</h4>
        <p class="value">{{ personDatas.personCount }}</p>
      </li> -->
      <li>
        <h4 class="bg-green">在园总人数</h4>
        <p>{{ personDatas.personInParkCount }}</p>
      </li>
      <li>
        <h4 class="bg-yellow">在园访客数</h4>
        <p>{{ personDatas.visitorCount }}</p>
      </li>
    </ul>
  </div>
  <!-- </el-scrollbar> -->
</template>

<script>
import API from "../api/index";
import echarts from "echarts";
export default {
  // props: {
  //   personData: {},
  // },
  // watch: {
  //   personData(newValue, oldValue) {
  //     console.log(newValue, ">>>newVal");
  //     this.personDatas = newValue;
  //     //   this.setChartsFilter("pieChart");
  //     //   this.setChartsFilter("sexChart");
  //   },
  // },
  data() {
    return {
      key: 0,
      personDatas: {
        personCount: 15478,
        personInParkCount: 13547,
        visitorCount: 1257,
        // totalNum: 21578,
      },
      personChart: null,
      personChartOption: {},
    };
  },
  created() { },
  mounted() {
    this.personChart = echarts.init(document.getElementById("pieChart"));
    this.queryPersonData().then((res) => {
      this.initChart();
    });
    // this.setChartsFilter("pieChart");
    // this.setChartsFilter('sexChart')
  },
  methods: {
    queryPersonData() {
      return new Promise((resolve, reject) => {
        this.$fetch(API.statPersonnelAllInPark, {}).then((res) => {
          if (res.success) {
            this.personDatas = res.returnObj;
            this.personDatas.totalNum =
              this.personDatas.personCount
            // this.personDatas.personInParkCount +
            // this.personDatas.visitorCount;
            resolve(this.personDatas);
          }
        });
      });
    },
    setChartsFilter(id) {
      //   let option = {
      //     title: {
      //       text: "今日人流量",
      //       textStyle: {
      //         color: "#FFFFFF",
      //         fontSize: 8,
      //       },
      //       left: "25",
      //       bottom: "0",
      //     },
      //     tooltip: {
      //       trigger: "item",
      //     },
      //     series: [
      //       {
      //         // name: "今日人流量",
      //         type: "pie",
      //         radius: "55%", //饼图的半径大小
      //         center: ["50%", "48%"], //饼图的位置
      //         label: {
      //           normal: {
      //             show: true,
      //             position: "inner",
      //             textStyle: {
      //               fontWeight: 300,
      //               fontSize: 12,
      //             },
      //             formatter: "{c}",
      //           },
      //         },
      //         data: [
      //           {
      //             value: this.personDatas.totalNum,
      //             itemStyle: { normal: { color: "#0364FF" } },
      //           },
      //         ],
      //         emphasis: {
      //           itemStyle: {
      //             shadowBlur: 5,
      //             shadowOffsetX: 0,
      //             shadowColor: "rgba(0, 0, 0, 0.5)",
      //           },
      //         },
      //       },
      //     ],
      //   };

      let myChart = charts.init(document.getElementById(id));
      var xdata = 50 //接收x数据
      var ydata = this.personDatas.totalNum; //接收x数据

      var datas_outer = []; //存放外层颜色小块
      var datas_inner = []; //存放内层颜色小块
      var num = 20; //定义小块个数
      var rate = xdata; //完成率

      for (var i = num; i >= 0; i--) {
        if (i <= rate * 20) {
          datas_outer.push({
            value: 1,
            name: "已完成",
            itemStyle: {
              color: "#1B7EF2", //浅绿色
              borderWidth: 4,
              borderColor: "#023151", //背景色 融入
            },
          });
          datas_inner.push({
            value: 1,
            name: "已完成",
            itemStyle: {
              color: "#1B7EF2", //深绿色
              borderWidth: 4,
              borderColor: "#023151", //背景色 融入
            },
          });
        } else {
          datas_outer.push({
            value: 1, //占位用
            name: "未完成",
            itemStyle: { color: "#1B7EF2" },
          });
          datas_inner.push({
            value: 1, //占位用
            name: "未完成",
            itemStyle: { color: "#1B7EF2" },
          });
        }
      }

      //定义图表option
      var option = {
        tooltip: {
          show: false,
        },
        title: {
          text: xdata, //中间标题
          x: "center",
          y: "center",
          textStyle: {
            color: "#FFFFFF",
            fontSize: "130%", //中间标题文字大小设置
          },
        },
        series: [
          {
            name: "完成情况外层",
            type: "pie",
            radius: ["80%", "40%"],
            center: ["50%", "50%"],
            clockwise: false,
            data: datas_outer,
            startAngle: 0,
            hoverAnimation: false,
            legendHoverLink: false,
            label: {
              show: false,
            },
            labelLine: {
              show: false,
            },
          },
          {
            name: "完成情况内层",
            type: "pie",
            radius: ["38%", "30%"],
            center: ["50%", "50%"],
            clockwise: false,
            data: datas_inner,
            startAngle: 180,
            hoverAnimation: false,
            legendHoverLink: false,
            label: {
              show: false,
            },
            labelLine: {
              show: false,
            },
          },
        ],
      };
      myChart.setOption(option);
      window.onresize = function () {
        //窗口适应
        myChart.resize();
      };

      myChart.setOption(option);
      setTimeout(() => {
        myChart.resize();
      }, 550);
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },
    initChart() {
      let data = [
        { value: this.personDatas.personInParkCount, name: "在园总人数" },
        // { value: this.personDatas.personInParkCount },
        { value: this.personDatas.visitorCount, name: "在园访客数" },
      ];
      let colorData = [
        { os1: "#503EFF", os2: "#216994" },
        { os1: "#14C9C9", os2: "#14C9C9" },
        {
          os1: "#F7BA1E ",
          os2: "#F7BA1E ",
        },
      ];
      let legendData = ["在园总人数", "在园访客数"];
      let seriesData = [];
      let radiusValue = 75;
      let total = 0;

      // data.forEach(function (val, idx, arr) {
      //   total += val.value;
      // });
      for (var i = 0; i < data.length; i++) {
        seriesData.push({
          type: "pie",
          clockWise: false, //饼图的扇区是否是顺时针排布
          radius: [radiusValue - 20 * i + "%", radiusValue - 20 * i + 1 + "%"],
          center: ["50%", "50%"],
          label: {
            normal: {
              show: false, //隐藏引导线标识
            },
          },
          hoverAnimation: false, //关闭 hover 在扇区上的放大动画效果
          startAngle: 150 * i, //起始角度
          data: [
            {
              //透明伞形
              value: data[i].value,
              // label: {
              //   normal: { show: true, position: "inner", formatter: "{d}%" },
              // },
              itemStyle: {
                //设置透明伞形
                normal: {
                  color: "#677FAF", //伞形颜色
                  borderWidth: 7,
                  borderColor: "#041e36",
                  label: {
                    show: true,
                  },
                },
              },
            },
            {
              value: data[i].value,
              name: data[i].name,
              // label: {
              //   normal: { show: true, position: "inner", formatter: "{d}%" },
              // },
              itemStyle: {
                normal: {
                  borderWidth: 10,
                  borderColor: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {
                      offset: 0,
                      color: colorData[i].os1,
                    },
                    {
                      offset: 1,
                      color: colorData[i].os2,
                    },
                  ]),
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {
                      offset: 0,
                      color: colorData[i].os1,
                    },
                    {
                      offset: 1,
                      color: colorData[i].os2,
                    },
                  ]),
                },
              },
            },
          ],
        });
      }
      this.personChartOption = {
        graphic: [
          {
            //环形图中间添加文字
            type: "text", //通过不同top值可以设置上下显示
            left: "center", //
            top: "40%",
            style: {
              text: this.personDatas.totalNum,
              textAlign: "center",
              fill: "#fff", //文字的颜色
              fontSize: 18,
              lineHeight: 16,
            },
          },
          {
            //环形图中间添加文字
            type: "text", //通过不同top值可以设置上下显示
            left: "center",
            top: "55%",
            style: {
              text: "今日人流量",
              textAlign: "center",
              fill: "#fff", //文字的颜色
              fontSize: 12,
              fontWeight: 400,
              lineHeight: 16,
            },
          },
        ],

        tooltip: {
          trigger: "item",
          show: true,
          // trigger: 'item',
          // formatter: "{a} <br/>{b}: {c} ({d}%)",

          backgroundColor: "rgba(0,0,0,0.7)", // 背景
          padding: [8, 10], //内边距
          extraCssText: "box-shadow: 0 0 3px rgba(255, 255, 255, 0.4);", //添加阴影
        },
        legend: {
          data: legendData,
          top: "-2%",
          bottom: "10%",
          textStyle: {
            color: "#fff",
            fontSize: 12,
          },
          itemWidth: 16,
          itemHeight: 12,
          itemGap: 12,
        },
        series: seriesData,
      };
      this.personChart = echarts.init(document.getElementById("pieChart"));
      this.personChart.setOption(this.personChartOption);
    },
  },
};
</script>

<style lang="scss" scoped>
.StatsBox {
  width: 100%;
  height: 100%;
  // display: flex;
  // flex-direction: column;
  padding-top: 15px;

  &__chart {
    flex: 1;
    // height: 0;
    height: 100px;
    width: 40%;
  }

  &__header {
    list-style: none;
    width: 50%;
    margin: auto;
    // display: flex;
    // flex-direction: row;
    // justify-content: space-around;
    // padding-left: 10px;
    // margin-top: 20px;

    li {
      // width: 182px;
      height: 52px;
      line-height: 52px;
      color: #fff;
      font-size: 12px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      // padding-right: 18px;

      h4 {
        padding: 0;
        margin: 0;
        // line-height: 1;
        // height: 18px;
        padding-left: 22px;
        padding-bottom: 4px;
        font-size: 18px;
        font-family: "Source Han Sans CN";
        font-weight: 500;
        color: #eff0f1;
        line-height: 21px;
      }

      p {
        width: 120px;
        margin-top: 10px;
        height: 24px;
        font-size: 28px;
        font-family: "zcoolqingkehuangyouti";
        font-weight: bold;
        // color: #6acbff;
        text-align: left;
        line-height: 27px;
      }

      .bg {
        width: 152px;
        text-align: right;
        font-family: YouSheBiaoTiHei;
        font-weight: 400;
        line-height: 52px;
        color: transparent;
        background-clip: text;
        -webkit-background-clip: text;
        font-size: 24px;
        padding-right: 18px;
        width: 100%;
        text-align: right;
      }

      .bg-blue {
        @extend.bg;
        // text-align: right;
        // font-family: YouSheBiaoTiHei;
        // font-weight: 400;
        // line-height: 52px;
        // color: transparent;
        // background-clip: text;
        // -webkit-background-clip: text;
        // font-size: 24px;
        // padding-right: 18px;
        // background-image: linear-gradient(to right, yellow, pink 50%)
        background-image: linear-gradient(90deg, #097ce7 0%, #ffffff 76%);
        // background: url("../assets/img/bg-blue.png") left bottom no-repeat;
      }

      .bg-green {
        @extend.bg;
        background-image: linear-gradient(90deg, #14c9c9 0%, #ffffff 76%);
        // background: url("../assets/img/bg-red.png") left bottom no-repeat;
      }

      .bg-yellow {
        @extend.bg;
        background-image: linear-gradient(90deg, #f7ba1e 0%, #ffffff 76%);

        // background: url("../assets/img/bg-yellow.png") left bottom no-repeat;
      }

      // .bg-red {
      //   background: url("../assets/img/bg-yellow.png") left bottom no-repeat;
      // }

      &.blue {
        border-left: #00cbff solid 8px;
        background: linear-gradient(to right,
            rgba(#00cbff, 0.6),
            rgba(#00cbff, 0));

        h4 {
          color: #00cbff;
        }
      }

      &.yellow {
        border-left: #ffc600 solid 8px;
        background: linear-gradient(to right,
            rgba(#ffc600, 0.6),
            rgba(#ffc600, 0));

        h4 {
          color: #ffc600;
        }
      }

      &.green {
        border-left: #00ff9c solid 8px;
        background: linear-gradient(to right,
            rgba(#00ff9c, 0.6),
            rgba(#00ff9c, 0));

        h4 {
          color: #00ff9c;
        }
      }
    }
  }
}
</style>
